// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"afeed364","513":"84960cd6","703":"06c99429","787":"8059fbe1"}[chunkId] + ".chunk.js";
};